import { render, staticRenderFns } from "./receipt-information.vue?vue&type=template&id=87ee3610&scoped=true"
import script from "./receipt-information.vue?vue&type=script&lang=js"
export * from "./receipt-information.vue?vue&type=script&lang=js"
import style0 from "./receipt-information.vue?vue&type=style&index=0&id=87ee3610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ee3610",
  null
  
)

export default component.exports